export const ConsentCard = {
  flow: 'y',
  gap: 'Y',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  transition: 'box-shadow .15s',
  ':hover': { boxShadow: '0 2px 12px 0 ink.10' },

  TopRow: {
    flow: 'x',
    align: 'center space-between',
    TreatmentName: {
      text: (el, s) => s.treatmentName || '{{ untitled | polyglot }}',
      fontSize: 'Z',
      fontWeight: '700',
      color: 'inkText'
    },
    StatusBadge: {
      tag: 'span',
      text: (el, s) => s.consentStatus || 'Pending',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const st = s.consentStatus || 'Pending'
        if (st === 'Signed') return 'green.15'
        if (st === 'Pending') return 'amber.15'
        if (st === 'Expired') return 'red.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.consentStatus || 'Pending'
        if (st === 'Signed') return 'green'
        if (st === 'Pending') return 'amber'
        if (st === 'Expired') return 'red'
        return 'inkMuted'
      }
    }
  },

  PatientName: {
    text: (el, s) => s.patientName || '',
    fontSize: 'Z',
    fontWeight: '600',
    color: 'inkText'
  },

  DateSigned: {
    text: (el, s) => s.dateSigned ? `{{ signed | polyglot }}: ${s.dateSigned}` : '{{ awaitingSignature | polyglot }}',
    fontSize: 'Y',
    color: 'inkMuted'
  },

  ViewBtn: {
    extends: 'Button',
    text: '{{ viewDetails | polyglot }}',
    fontSize: 'Y',
    padding: 'Y Z',
    round: 'Z',
    background: 'teal',
    color: 'white',
    fontWeight: '600',
    cursor: 'pointer',
    alignSelf: 'flex-start'
  }
}
